import { axiosInstance, handleApiRequest } from './apiClient';
import { TopicResponse } from 'types/topic';

const topicAPI = {
  getTopics: async () => {
    return handleApiRequest<TopicResponse>(axiosInstance.get(`/topics`));
  },
};

export default topicAPI;
